<template>
  <div class="hzc-price-index"> 
    <div>当前位置：<span style="cursor: pointer" @click="back">焦炭</span> > <span>新增/淘汰产能</span>  > 正文</div>
    <DetailTitle :title="'焦炭新增淘汰产能'"></DetailTitle>
    <el-table
        :data="tableData"
        :header-cell-style="{background:'#f2f2f2',color:'#222'}"
        border
        :max-height="400"
        style="width: 100%">
      <el-table-column
          align="center"
          prop="companyName"
          label="企业名称">
      </el-table-column>
      <el-table-column
          align="center"
          prop="companyProvince"
          label="责任市">
      </el-table-column>
      <el-table-column
          align="center"
          prop="cokeTye"
          label="焦炉型号">
      </el-table-column>
      <el-table-column
          align="center"
          prop="cokeProcess"
          label="焦炉工艺"
          :formatter="cokeProcessFormat" >
      </el-table-column>
      <el-table-column
          align="center"
          prop="cokeWay"
          label="熄焦方式"
          :formatter="cokeWayFormat">
      </el-table-column>
      <el-table-column
          align="center"
          prop="companyProvince"
          label="炼焦装备（碳化室高度*孔数*组数）">
        <template slot-scope="scope">
          <span v-if="scope.row.cokeEquipmentHigh==null&&scope.row.cokeEquipmentHoles==null&&scope.row.cokeEquipmentSeries==null"></span>
          <span v-else>{{ `${scope.row.cokeEquipmentHigh||""}*${scope.row.cokeEquipmentHoles||""}*${scope.row.cokeEquipmentSeries||""}` }}</span>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="capacity"
          label="总产能（万吨）">
      </el-table-column>
      <el-table-column
          align="center"
          prop="capacity"
          label="新增/淘汰">
        <template slot-scope="scope">
          <span>{{scope.row['dataType'] === 1?'新增':'淘汰'}}</span>
<!--          <span :class="{'red':scope.row['dataType'] === 1}"-->
<!--                v-if="scope.row['dataType'] === 1">{{ `+${scope.row['capacity']}` }}</span>-->
<!--          <span :class="{'green':scope.row['dataType'] === 2}" v-else>{{ `-${scope.row['capacity']}` }}</span>-->
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="productionTime"
          label="投产/退出增时间">
      </el-table-column>
      <el-table-column
          align="center"
          prop="createBy"
          label="录入人">
      </el-table-column>
    </el-table>
    <DetailTitle :title="'焦炭预计产能'"></DetailTitle>
    <p class="p">{{time}}月份全国焦炭产能为{{capacitySum}}万吨</p>
    <el-table
        :data="bomTable"
        :header-cell-style="{background:'#f2f2f2',color:'#222'}"
        border
        :max-height="400"
        style="width: 100%">
      <el-table-column
          align="center"
          prop="productionTime"
          label="时间">
      </el-table-column>
      <el-table-column
          align="center"
          prop="addNumber"
          label="新增产能">
      </el-table-column>
      <el-table-column
          align="center"
          prop="reduceNumber"
          label="淘汰产能">
      </el-table-column>
      <el-table-column
          align="center"
          prop="realNumber"
          label="产能变化">
        <template slot-scope="scope">
          <span :class="{'red':scope.row['realNumber'] > 0}"
                v-if="scope.row['realNumber'] > 0">{{ `+${scope.row['realNumber']}` }}</span>
          <span :class="{'green':scope.row['realNumber'] < 0}" v-else>{{ `${scope.row['realNumber']}` }}</span>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="estimateNumber"
          label="焦炭预计产能">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import DetailTitle from '@/components/common/detatilTitle'
import {boardDetail} from '@/api/coke'
import { selectDictLabel } from "@/utils/ruoyi";
import {type} from '@/api'

export default {
  components: {
    DetailTitle
  },
  data() {
    return {
      tableData: [],
      bomTable: [],
      cokeProcess: [],
      cokeWay: [],
      capacitySum:0,
      time:''
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      boardDetail(this.$route.query.id).then(res => {
        this.tableData = res.data.data;
        this.bomTable = res.data.sumList;
        this.time = res.data.nowTime;
        this.capacitySum = res.data.capacitySum
      })
    type("base_coke_process").then((res)=>{
        this.cokeProcess = res.data
    })
    type("base_coke_way").then((res)=>{
      this.cokeWay = res.data
    })
    },
    // 焦炉工艺字典翻译
    cokeProcessFormat(row, column) {
      return selectDictLabel(this.cokeProcess, row.cokeProcess);
    },
    // 焦炉方式字典翻译
    cokeWayFormat(row, column) {
      return selectDictLabel(this.cokeWay, row.cokeWay);
    },
    /**
     * 回退
     */
    back() {
      this.$router.push('/coke')
    },
  }
}
</script>

<style scoped lang="less">
.hzc-price-index {
  width: 1200px;
  margin: 0 auto;

  .el-table {
    margin-top: 16px;
  }

  .p {
    display: inline-block;
    font-size: 22px;
    font-weight: 500;
    vertical-align: middle;
    height: 30px;
    line-height: 30px;
    margin-left: 20px;
    margin-top: 10px;
  }
}

.red {
  color: #EA6535;
}

.green {
  color: #079F93;
}
</style>
